import { CancelOutlined, DescriptionOutlined } from '@mui/icons-material'
import {
	Button,
	Dialog,
	IconButton,
	Paper,
	PaperProps,
	Theme,
	Typography,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { percent } from 'csx'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { useMemo, useState } from 'react'
import { FormBuilderSchema } from '../../../FormBuilderCore/Types'
import { specifyInternalComponent } from '../../../FormBuilderCore/cells/ComponentSpecification'
import { useInputCellContext } from '../../../FormBuilderCore/cells/rendering/contexts/InputContextProvider'
import FieldType from '../../../FormHost/Types/FieldType'
import { DocumentFormat } from '../../../Ocr/OcrTypes'
import { OcrScreenDesigner } from '../../Runtimes/Designer/OcrScreenDesigner'

type OcrCorrectionScreenConfiguratorProps = Record<string, unknown>

export type OcrCorrectionScreenValue = {
	formBuilderSchema: FormBuilderSchema
	documentFormat: DocumentFormat
}

export const OcrCorrectionScreenConfigurator = observer(
	(props: OcrCorrectionScreenConfiguratorProps) => {
		const styles = useWrapperStyles()

		const [dialogOpen, setDialogOpen] = useState(false)

		const context = useInputCellContext<OcrCorrectionScreenValue>()

		const handleOpenDialog = () => {
			setDialogOpen(true)
		}

		const handleCloseDialog = () => {
			setDialogOpen(false)
		}

		console.log('CONTEXT.VALUE', context.cellInstance)

		return (
			<div className={styles.wrapperParentDiv}>
				<Button
					color="primary"
					variant="outlined"
					startIcon={<DescriptionOutlined />}
					onClick={handleOpenDialog}
				>
					Design OCR Correction Screen
				</Button>
				<OcrCorrectionScreenConfiguratorDialog
					open={dialogOpen}
					onClose={handleCloseDialog}
					value={
						context.value ?? {
							documentFormat: DocumentFormat.Portrait,
							formBuilderSchema: {} as FormBuilderSchema,
						}
					}
					onValueChange={context.onChange}
				/>
			</div>
		)
	},
)

type OcrCorrectionScreenConfiguratorDialogProps = {
	open: boolean
	onClose: () => void
	value: OcrCorrectionScreenValue
	onValueChange: (value: OcrCorrectionScreenValue) => void
}

const useWrapperStyles = makeStyles((theme: Theme) => ({
	wrapperParentDiv: {
		padding: theme.spacing(1),
		flex: 1,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
}))

const OcrCorrectionScreenConfiguratorDialog: React.FC<OcrCorrectionScreenConfiguratorDialogProps> =
	observer((props: OcrCorrectionScreenConfiguratorDialogProps) => {
		const styles = useStyles()

		const paperProps = useMemo<PaperProps>(
			() => ({
				className: styles.bsPaperStyle,
			}),
			[],
		)

		// const observableFormBuilderSchema = useMemo(
		// 	() => observable(props.value.formBuilderSchema),
		// 	[props.value.formBuilderSchema],
		// )

		const observableValue = useMemo(
			() => observable(props.value),
			[props.value],
		)

		return (
			<>
				<Dialog
					PaperComponent={Paper}
					PaperProps={paperProps}
					open={props.open}
					onClose={props.onClose}
					maxWidth="xl"
					fullWidth
				>
					<div className={styles.bsScrollbarBarrierStyle}>
						<div className={styles.container}>
							<div className={styles.header}>
								<Typography variant="h5">
									OCR Correction Screen Designer
								</Typography>
								<IconButton
									onClick={props.onClose}
									className={styles.headerCloseButton}
									size="large"
								>
									<CancelOutlined color="primary" />
								</IconButton>
							</div>
							<OcrScreenDesigner ocrScreenValue={observableValue} />
						</div>
					</div>
				</Dialog>
			</>
		)
	})

const useStyles = makeStyles((theme: Theme) => ({
	bsPaperStyle: {
		height: '100%',
	},
	bsScrollbarBarrierStyle: {
		display: 'flex',
		flex: 1,
		overflow: 'hidden',
	},

	container: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		padding: theme.spacing(2),
	},

	header: {
		width: percent(100),
		display: 'flex',
	},
	headerCloseButton: {
		marginLeft: 'auto',
	},

	containerHeader: {},
}))

export const OcrCorrectionScreenConfiguratorElementTag =
	'aa4d7eed-f57f-4696-8c9a-af98d8391005'

const OcrCorrectionScreenConfiguratorId = '1cac8d28-f6de-401a-ab25-1adac6d7e603'

export const OcrCorrectionScreenConfiguratorDefinition =
	specifyInternalComponent(
		OcrCorrectionScreenConfiguratorId,
		OcrCorrectionScreenConfigurator,
		OcrCorrectionScreenConfiguratorElementTag,
		FieldType.ReferenceType,
		{},
		{
			documentFormat: DocumentFormat.Portrait,
			formBuilderSchema: {
				definitions: [],
				handlers: {
					actions: [],
					dependencies: {},
				},
			},
		},
	)
